import type { Role } from '@bm/shared';
import { de } from '@/i18n/de';
import { AppShell } from '@/components/AppShell';
import { Button } from '@/components/Button';
import { RoleCard } from '@/components/RoleCard';

interface LocalRevealScreenProps {
  name: string;
  role: Role;
  colleagueNames: string[];
  onSeen: () => void;
}

export function LocalRevealScreen({ name, role, colleagueNames, onSeen }: LocalRevealScreenProps) {
  return (
    <AppShell
      footer={
        <div className="mx-auto max-w-xl">
          <Button fullWidth onClick={onSeen}>
            {de.local.seen}
          </Button>
        </div>
      }
    >
      <div className="flex h-full flex-col items-center justify-center gap-6">
        <p className="font-display text-lg font-semibold">{name}</p>
        {/* key: erzwingt eine frische, verdeckte Karte pro Spieler. */}
        <RoleCard key={name} role={role} colleagueNames={colleagueNames} />
      </div>
    </AppShell>
  );
}
